var jquery1_12_4 = {
  exports: {}
};

export { jquery1_12_4 as j };
//# sourceMappingURL=jquery-1.12.4.js.map
